export * from './data-base-slider';
export * from './home-slider';
export * from './speakers-slider';
export * from './lector-review-slider';
